export default function WeatherTable(props) {
  const {
    temperature_2m,
    apparent_temperature,
    precipitation,
    wind_speed_10m,
    cloud_cover,
    relative_humidity_2m,
    temp_f,
    feelslike_f,
    precip_in,
    wind_mph,
  } = props.weather;

  return (
    <table className="table shadowCard weatherTable">
      <thead className="table-success">
        <tr>
          <th scope="row"></th>
          <th>Temperature</th>
          <th>Feels Like</th>
          <th>Precipitation</th>
          <th>Wind</th>
          <th>Cloud</th>
          <th>Humidity</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row"></th>
          <td>{temperature_2m} C</td>
          <td>{apparent_temperature} C</td>
          <td>{precipitation} mm</td>
          <td>{wind_speed_10m} KPH</td>
          <td>{cloud_cover}</td>
          <td>{relative_humidity_2m}</td>
        </tr>
        <tr>
          <th scope="row"></th>
          <td>{temp_f} F</td>
          <td>{feelslike_f} F</td>
          <td>{precip_in} in</td>
          <td colSpan="3">{wind_mph} MPH</td>
        </tr>
      </tbody>
    </table>
  );
}
